export const surveyParcels = (state = {}, action) => {
  switch (action.type) {
    case 'ADD_SURVEY_PARCELS': {
      const newState = { ...state };
      const { surveyId, surveyParcels: parcels } = action.payload;
      newState[surveyId] = newState[surveyId] || {};

      parcels.forEach((surveyParcel) => {
        newState[surveyId][surveyParcel.id] = surveyParcel;
      });

      return newState;
    }
    case 'REMOVE_SURVEY_PARCELS': {
      const newState = { ...state };
      const { surveyId, surveyParcels: parcels } = action.payload;

      parcels.forEach((surveyParcel) => {
        delete newState[surveyId][surveyParcel.id];
      });

      return newState;
    }
    case 'ADD_FIELD_CHANGE': {
      const newState = { ...state };
      const { surveyId, surveyParcelId, fieldChange } = action.payload;

      newState[surveyId][surveyParcelId].field_changes = [
        fieldChange,
        ...newState[surveyId][surveyParcelId].field_changes,
      ];
      return newState;
    }
    case 'REMOVE_FIELD_CHANGE': {
      const newState = { ...state };
      const { surveyId, surveyParcelId, fieldChange } = action.payload;

      newState[surveyId][surveyParcelId].field_changes = newState[surveyId][
        surveyParcelId
      ].field_changes.filter((change) => change.id !== fieldChange.id);
      return newState;
    }
    default:
      return state;
  }
};
